import { DataBean } from "../../DataBean";


export class HealthOrphanDisease extends DataBean {


    public async getHealthOrphanDiseaseCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthOrphanDiseaseCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}